import { Download, Loader2, ChevronDown } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { useCurrentUser } from '@/hooks'
import { useExportOrganization, type ExportParams } from '@/hooks'

interface ExportButtonProps {
  filters?: Omit<ExportParams, 'format'>
}

export function ExportButton({ filters }: ExportButtonProps) {
  const { data: user } = useCurrentUser()
  const exportMutation = useExportOrganization()

  // 只有 director 和 hr 可以导出
  const canExport = user?.role === 'director' || user?.role === 'hr'

  if (!canExport) {
    return null
  }

  const handleExport = async (format: 'csv' | 'excel') => {
    try {
      await exportMutation.mutateAsync({
        format,
        ...filters,
      })
    } catch {
      // 错误已在 mutation 中处理
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" disabled={exportMutation.isPending}>
          {exportMutation.isPending ? (
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          ) : (
            <Download className="mr-2 h-4 w-4" />
          )}
          导出
          <ChevronDown className="ml-2 h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => void handleExport('csv')}>
          导出为 CSV
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => void handleExport('excel')}>
          导出为 Excel
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
